import React from 'react'
import tickting from '../../../../assets/img/360_ticking.webp'
import wrkface from '../../../../assets/img/work_face.webp'
import ditcre from '../../../../assets/img/diet_care.webp'
import google from '../../../../assets/img/goole_play.webp'
import app from '../../../../assets/img/app_store.webp'
import ticketing from '../../../../assets/img/360_ticketing.webp'
import Workface from '../../../../assets/img/workface.svg'
import dietcare from '../../../../assets/img/dietcare.svg'
import { FaChevronRight } from 'react-icons/fa6'
import './Projects.css'
import { useNavigate } from 'react-router-dom';

function Projects() {
    const navigate = useNavigate();
    const PtojectList = [
        {
            logo:ticketing,
            tittle:"Ticketing Solution",
            desc: "Q-Tickets is the no.1 ticketing platform in the Middle-East offering a complete range of ticketing services for cinemas, concerts, events, festivals, shows, sports tournaments, arts, theaters globally. Headquartered in Qatar, the company holds a strong presence across 6 countries and is a revolutionary one-stop solution provider to all things entertainment.",
            platforms: "iOS, Android, Web",
            technology: ".net Core",
            waimg: [google, app],
            img: tickting,
            link: "https://360-ticketing.com/"
        },
        {
            logo:Workface,
            tittle:"Workforce Management",
            desc: "Workface is a cutting-edge software solution developed by 360 Gigabytes, designed to revolutionize workforce management. We understand the complexities of running an organization, which is why our software is designed to integrate seamlessly with your existing ERP systems, enhancing efficiency across multiple domains.",
            platforms: "iOS, Android, Web",
            technology: "Laravel, PHP",
            waimg: [google, app],
            img: wrkface,
            link: "/workforce-management"
        },
        {
            logo:dietcare,
            tittle:"Diet Care",
            desc: "Diet Care is a revolutionary diet and nutrition application designed to fit your nutriment and fitness standards in every way possible. With personalized solutions to cater to the health goals you have set for yourself, Diet Care offers you the best with a whole lot of care.",
            platforms: "Web",
            technology: "Laravel, PHP",
            waimg: [],
            img: ditcre,
            link: "/diet-care"
        }
    ]

  return (
    <section className='pro-sec'>
        <div className='container'>
          <h3>Our Products</h3>
        </div>
        <div className='container'>
            {
                PtojectList.map((item,index)=>(
                    <div className='hmproject-area' key={index}>
                    <div className='hmproject-img'><img src={item.img} alt={item.tittle} width={1200} height={800} loading="lazy"/></div>     
                    <div className='hmproject-txt'>
                        {/*<img src={item.logo} alt='' loading="lazy" width={'200px'} height={'60px'}/>*/ }
                        <h4>{item.tittle}</h4>
                        <p>{item.desc}</p>
                        <div className='platech'>
                            <div className='platech-sec'>
                                <h5>Platforms</h5> 
                                <h6>{item.platforms}</h6>  
                            </div>
                            <div className='platech-sec'>
                                <h5>Technology</h5> 
                                <h6>{item.technology}</h6>  
                            </div>
                        </div>
                        <div className='plapla'>
                        {item.waimg.map((image, imgIndex) => (
                            <img key={imgIndex} src={image} alt={`App store ${imgIndex}`} width={130} height={40} loading="lazy" />
                            ))}
                            
                        </div>
                        <button className='btn-main' 
                        onClick={() => {
                            if (item.link.startsWith("http")) {
                                window.open(item.link, '_blank', 'noopener,noreferrer');
                            } else {
                                navigate(item.link);
                            }
                            }}
                        ><span>Learn More</span> <FaChevronRight/></button>
                    </div> 
                    </div>
                ))
            }
            
        </div>
    </section>
  )
}

export default Projects
